import React from "react";

const WhyChooseSection = () => {
  return (
    <section className="section why-choose">
      <div className="choose-left">
        <img
          src="/img/bg/choose-left.png"
          className="img-fluid"
          alt="Why Choose Us"
        />
      </div>

      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2>Why Choose SRS Cab Service</h2>
          <p>
            We provide reliable, safe, and affordable cab services designed to make your journey smooth and stress-free.
          </p>
        </div>

        {/* Cards */}
        <div className="why-choose-group">
          <div className="row">
            {/* Card 1 */}
            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="choose-img choose-black">
                    <img src="/img/icons/bx-selection.svg" alt="Easy Booking" />
                  </div>
                  <div className="choose-content">
                    <h4>Easy & Quick Booking</h4>
                    <p>
                      Book your ride in just a few clicks. Our simple and user-friendly process saves your time and gets you on the road faster.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="choose-img choose-secondary">
                    <img src="/img/icons/bx-crown.svg" alt="Wide Coverage" />
                  </div>
                  <div className="choose-content">
                    <h4>Wide Service Coverage</h4>
                    <p>
                      We offer pickup and drop services across city and outstation locations, ensuring convenient travel wherever you go.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="choose-img choose-primary">
                    <img src="/img/icons/bx-user-check.svg" alt="Customer Satisfaction" />
                  </div>
                  <div className="choose-content">
                    <h4>100% Customer Satisfaction</h4>
                    <p>
                      Your comfort and safety are our priority. Our professional drivers and well-maintained cars ensure a smooth and pleasant ride every time.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;